import type { ElementType, HTMLAttributes } from 'react';
import type { LayoutGap } from '../Stack/Stack';
import './Grid.css';

/** Minimum column width before the grid wraps: sm 14rem · md 18rem · lg 24rem. */
export type GridMinItemWidth = 'sm' | 'md' | 'lg';

export interface GridProps extends HTMLAttributes<HTMLElement> {
  /** Minimum item width for the auto-fit columns. Defaults to 'md'. */
  minItemWidth?: GridMinItemWidth;
  /** Gap between cells, `var(--spacing-{gap})`. Defaults to '4'. */
  gap?: LayoutGap;
  /** Element to render. Defaults to 'div'. */
  as?: ElementType;
  className?: string;
}

/**
 * Grid — responsive auto-fit grid. Columns are at least `minItemWidth` wide and
 * share the remaining space; on narrow viewports it collapses to one column.
 */
export function Grid({
  minItemWidth = 'md',
  gap = '4',
  as: Tag = 'div',
  className = '',
  children,
  ...rest
}: GridProps) {
  const classes = ['rg-grid', `rg-grid--min-${minItemWidth}`, `rg-grid--gap-${gap}`, className]
    .filter(Boolean)
    .join(' ');
  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

export default Grid;
